<app-basic-cta
  [title]="'Discover More with a Plan Upgrade!'"
  [primaryButtonText]="'View Plans'"
  [secondaryButtonText]="'Continue using current plan'"
  (primaryClick)="primaryClick.emit()"
  (secondaryClick)="dismiss.emit()"
>
  <img
    image
    ngSrc="../../../../assets/ctas/cta-upgrade@2x.png"
    width="250"
    height="250"
    priority
  />

  <ng-container content>
    Expand your capabilities by upgrading to a higher plan. Get access to
    premium tools and services that will elevate your Celo experience.
  </ng-container>
</app-basic-cta>
